module.exports = __webpack_public_path__ + "img/isatis.61e2ab89.png";